import React from 'react'
import { FieldWrapper, Input, Label } from './Components'

const SectionTitleRow = ({ sectionIndex, touched, errors }) => {
  return (
    <div className='align-items-center title-row'>
      <FieldWrapper>
        <Label htmlFor={`sections[${sectionIndex}].title`}>Title</Label>
        <Input
          name={`sections[${sectionIndex}].title`}
          placeholder='Section Title'
          type='text'
        />
        {touched.sections?.[sectionIndex]?.title &&
          errors.sections?.[sectionIndex]?.title && (
            <div className='text-danger'>
              {errors.sections[sectionIndex].title}
            </div>
          )}
      </FieldWrapper>
      <FieldWrapper>
        <Label htmlFor={`sections[${sectionIndex}].description`}>
          Description
        </Label>
        <Input
          name={`sections[${sectionIndex}].description`}
          placeholder='Section Description'
          type='text'
        />
        {touched.sections?.[sectionIndex]?.description &&
          errors.sections?.[sectionIndex]?.description && (
            <div className='text-danger'>
              {errors.sections[sectionIndex].description}
            </div>
          )}
      </FieldWrapper>
    </div>
  )
}

export default SectionTitleRow
